import { BROADCAST_SET_ATTENDEE_CONNECTION_METRICS } from 'actions/Types';

export default (attendeeId, metrics) => {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_ATTENDEE_CONNECTION_METRICS,
      payload: { attendeeId, metrics }
    };

    dispatch(action);
  };
};
